import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import InnocentTeam from "../assets/img/innocent.jpg";
import MalusiTeam from "../assets/img/malusi.jpg";
import SilenceTeam from "../assets/img/silence.jpg";

// Reusable Team Member Card Component
interface TeamMember {
  image: string;
  name: string;
  position: string;
  contact: string;
  email: string;
  website: string;
}

const TeamMemberCard: React.FC<TeamMember> = ({ image, name, position, contact, email, website }) => {
  return (
    <Card
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      <ProfileImage src={image} alt={name} />
      <Name>{name}</Name>
      <Position>{position}</Position>
      <ContactInfo>
        <p>{contact}</p>
        <p>{email}</p>
        <p><a href={`https://${website}`}>{website}</a></p>
      </ContactInfo>
    </Card>
  );
};


// Main Team Section Component
const TeamSection = () => {
  const teamMembers = [
    {
      image: SilenceTeam,
      name: "Silence Mhlanga",
      position: "Director",
      contact: "+27 71 031 0957",
      email: "silencem@tersaconstruction.co.za",
      website: "www.tersaconstruction.co.za",
    },
    {
      image: InnocentTeam,
      name: "Innocent Manonga",
      position: "Project Manager",
      contact: "+27 76 317 7575",
      email: "innocentm@tersaconstruction.co.za",
      website: "www.tersaconstruction.co.za",
    },
    {
      image: MalusiTeam,
      name: "Malusi Magwaza",
      position: "Director",
      contact: "+27 79 595 5198",
      email: "malusim@tersaconstruction.co.za",
      website: "www.tersaconstruction.co.za",
    },
  ];

  return (
    <TeamContainer id="team">
      <Content>
        <Title
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          Meet Our Team
        </Title>
        <TeamGrid>
          {teamMembers.map((member, index) => (
            <TeamMemberCard
              key={index}
              image={member.image}
              name={member.name}
              position={member.position}
              contact={member.contact}
              email={member.email}
              website={member.website}
            />
          ))}
        </TeamGrid>
      </Content>
    </TeamContainer>
  );
};

// Styled Components
const TeamContainer = styled.section`
  background-color: #f3f6fb;
  color: #003366;
  padding: 80px 20px;
`;

const Content = styled.div`
  width: 80%; /* Restrict width to 80% */
  margin: auto; /* Center content horizontally */
  text-align: center;
`;

const Title = styled(motion.h2)`
  font-size: 2.5rem;
  margin-bottom: 40px;
  font-weight: bold;
  text-transform: uppercase;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const TeamGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
`;

const Card = styled(motion.div)`
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: transform 0.3s;

  &:hover {
    transform: translateY(-10px);
  }
`;

const ProfileImage = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin-bottom: 20px;
  object-fit: cover;
`;

const Name = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 10px;
  color: #003366;
`;

const Position = styled.p`
  font-size: 1.2rem;
  color: #ffa500;
  margin-bottom: 20px;
`;

const ContactInfo = styled.div`
  font-size: 1rem;
  color: #003366;
  line-height: 1.6;

  a {
    color: #003366;
    text-decoration: none;
    font-weight: bold;

    &:hover {
      color: #ffa500;
    }
  }
`;

export default TeamSection;
